class LocalStorage {
    static set(name, value) {
        LocalStorage.data[name] = value;
        try {
            if (window.localStorage) {
                window.localStorage.setItem(name, value);
            }
        } catch (e) {
        // NOTE: Ha nincs ilyen funkció akkor nem használjuk
        }
    }
    static get(name) {
        try {
            if (window.localStorage) {
                return window.localStorage.getItem(name);
            }
        } catch (e) {
        // NOTE: Ha nincs ilyen funkció akkor nem használjuk
        }
        return LocalStorage.data[name];
    }
    static remove(name) {
        LocalStorage.data[name] = undefined;
        try {
            if (window.localStorage) {
                window.localStorage.removeItem(name);
            }
        } catch (e) {
        // NOTE: Ha nincs ilyen funkció akkor nem használjuk
        }
    }
}
LocalStorage.data = {};

export { LocalStorage };
//# sourceMappingURL=local-storage.js.map
